import * as types from 'store/modules/hres92u/mutation-types'
import hres92u from 'api/hres92u'
import swal from 'sweetalert'
import { sendApprove } from 'assets/js/sendApprove.js'
import hres92uLabels from 'assets/labels/hres92u'
import { hres92uColumns } from 'assets/columns/hres92u'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres92uLabels,
    columns: hres92uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {}
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES92U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES92U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES92U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES92U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES92U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES92U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES92U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES92U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES92U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES92U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES92U_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRES92U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES92U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES92U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES92U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES92U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES92U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES92U_COLUMNS_LABELS] ({ commit }) {
      hres92u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES92U_COLUMNS, data.labels)
          commit(types.SET_HRES92U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES92U_INDEX] ({ commit }, searchParams) {
      hres92u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES92U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES92U_DETAIL] ({ commit }, searchParams) {
      hres92u.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES92U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES92U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres92u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES92U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres92u/index.js